import React from 'react'
import type { TaskRemarksActivityProps } from '@ztechapps/webui.contract'
import { useTaskListContext } from './Context'
import { ActivityLayout } from '@ztechapps/webui.data-tools'

export const RemarksActivity = ({ remarksActivity, _id }: TaskRemarksActivityProps) => {
  const { disabled } = useTaskListContext()

  return <ActivityLayout disabled={disabled} activities={remarksActivity} documentId={_id} entityName={'Task'} />
}
